import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useScale } from '../../hooks/useScale';
import { useColors } from '../../hooks/useColors';
import theme from '../../common/theme';

const ModifierStylingSettingsStyles = () => {
  const { scale } = useScale();
  const { colors } = useColors();

  return useMemo(
    () =>
      StyleSheet.create({
        headerRow: {
          flexDirection: 'row',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          columnGap: scale(12),
          marginBottom: scale(12),
        },
        headerText: {
          flex: 1,
          rowGap: scale(4),
        },
        description: {
          color: colors.textLight,
          fontSize: scale(13),
          lineHeight: scale(18),
          paddingHorizontal: scale(14),
          fontFamily: theme.fonts.regular,
        },
        headerButtons: {
          flexDirection: 'row',
          alignItems: 'center',
          columnGap: scale(10),
        },
        row: {
          flexDirection: 'row',
          alignItems: 'center',
          columnGap: scale(12),
          paddingVertical: scale(12),
          paddingHorizontal: scale(14),
          marginBottom: scale(8),
          borderRadius: theme.radius.m,
          backgroundColor: colors.elevation1,
        },
        swatch: {
          width: scale(28),
          height: scale(28),
          borderRadius: theme.radius.s,
        },
        swatchEmpty: {
          backgroundColor: colors.inputBackground,
        },
        rowText: {
          flex: 1,
          rowGap: scale(2),
        },
        rowTitle: {
          color: colors.text,
          fontSize: scale(15),
          fontFamily: theme.fonts.medium,
        },
        rowSubtitle: {
          color: colors.textLight,
          fontSize: scale(13),
          fontFamily: theme.fonts.regular,
        },
        rowRight: {
          flexDirection: 'row',
          alignItems: 'center',
          columnGap: scale(10),
        },
        italicBadge: {
          width: scale(28),
          height: scale(28),
          borderRadius: theme.radius.s,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: colors.elevation2,
        },
        italicBadgeText: {
          color: colors.text,
          fontSize: scale(14),
          fontStyle: 'italic',
          fontFamily: theme.fonts.medium,
        },
        emptyState: {
          color: colors.textLight,
          fontSize: scale(13),
          lineHeight: scale(18),
          paddingHorizontal: scale(14),
          paddingVertical: scale(12),
        },
      }),
    [colors, scale],
  );
};

export default ModifierStylingSettingsStyles;
